import { useGoogleTagManager, useMixpanel, useSentry } from '@/vendors/integrations'

export function useTrackingAction () {
  const gtm = useGoogleTagManager()
  const mixpanel = useMixpanel()
  const { withErrorHandler } = useSentry()

  const trackShareButtonClicked = ({ network, target_id, target_type }) => {
    withErrorHandler(() => {
      gtm.track({
        event: 'share',
        share_method: network,
        target_id,
        target_type
      })
    })
  }

  const trackSearchExecuted = ({ query }) => {
    withErrorHandler(() => {
      gtm.track({
        event: 'search',
        search_term: query
      })
    })
  }

  const trackPageViewed = ({ from, to }) => {
    withErrorHandler(() => {
      if (from.name === to.name && from.path === to.path) return

      mixpanel.track('Page view', {
        'Name': to.name,
        'Path': to.path,
        'Locale': to.params.locale,
        'Initial page': from.name === undefined
      })
    })
  }

  const trackLinkClicked = ({ type, text, url, id, name, params }) => {
    withErrorHandler(() => {
      gtm.track({
        event: 'click_link',
        link_type: type,
        link_text: text,
        link_url: url,
        target_id: id,
        target_name: name,
        target_params: params
      })
    })
  }

  return {
    trackShareButtonClicked,
    trackSearchExecuted,
    trackPageViewed,
    trackLinkClicked
  }
}
